import { useEffect, useState } from 'react';
import { useAppSelector } from '../redux/hooks';
import { selectUser } from '../redux/reducers/userSlice';
import { useGetClassesByRole } from './useGetClassesByRole';
import { AllDropdowns } from '../components/ReportHub/ReportHubModals/GenerateReport/ReportHubModal';
import { Roles } from '../models/User';
import { sortByKey } from '../businessLogicService/sortCriteria';
import removeTargetDuplicates from '../businessLogicService/removeTargetDuplicates';
import { formatClassDisplayName } from '../utils/formatClassDisplayName';

export const useGetDropdownsOptionForReports = () => {
  const userRedux = useAppSelector(selectUser);
  const { allClassesData } = useGetClassesByRole(true, true, true);
  const [allDropdowns, setAllDropdowns] = useState<AllDropdowns>({
    sites: [],
    roadmaps: [],
    classes: [],
  });

  const isAdmin = userRedux?.roles?.some(role => role?.name === Roles.NETWORK_ADMIN || role?.name === Roles.SITE_ADMIN);

  useEffect(() => {
    if (allClassesData.length) {
      const sitesData =
        userRedux?.sites?.map(site => ({
          value: site.id,
          label: site.name,
        })) || [];

      const classesData = !isAdmin
        ? allClassesData.map(cls => ({
            value: cls.id,
            label: formatClassDisplayName(cls),
          }))
        : [];

      const roadmapsData =
        userRedux?.sites
          ?.map(
            site =>
              site.targetGroups?.map(tg => ({
                value: tg.id,
                label: tg.name,
              })) || [],
          )
          .flat() || [];

      setAllDropdowns({
        sites: sitesData.sort(sortByKey('label')),
        classes: classesData.sort(sortByKey('label')),
        roadmaps: removeTargetDuplicates(roadmapsData.sort(sortByKey('label'))),
      });
    }
  }, [allClassesData]);

  return {
    allDropdowns,
    setAllDropdowns,
    allClassesData,
  };
};
